import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerSuggestionFreestyleTool,
  BackendMutationDeleteCustomerSuggestionFreestyleToolArgs,
} from 'src/types/backend';

import { FRAGMENT_FREESTYLE_TOOL } from './schema';

const MUTATION = gql`
  mutation DeleteCustomerSuggestionFreestyleTool($id: ID!) {
    deleteCustomerSuggestionFreestyleTool(id: $id) {
      ...SuggestionFreestyleTool
    }
  }
  ${FRAGMENT_FREESTYLE_TOOL}
`;

type Variables = BackendMutationDeleteCustomerSuggestionFreestyleToolArgs;
type Result = BackendCustomerSuggestionFreestyleTool;

export const deleteSuggestionFreestyleTool = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
